<template>
    <common-page>
        <b-overlay
            :show="!hasInit"
            spinner-variant="primary"
            spinner-type="grow"
            class="w-100 h-100">
            <workflow-task-batch v-if="hasInit" :configs="configs" entity-name="sithMesMstMaterial" :rows="rows"
                                 :end-call-api="endCallApi">
                <template #customAction="{status}">
                    <b-button v-if="status==='task7'" variant="outline-primary"
                              @click="downloadWithHeader(downloadTxtZipUrl(),'TXT collection.zip')">
                        主数据TXT
                    </b-button>
                    <b-button v-if="headerMaterials" variant="outline-success" class="ml-1"
                              v-b-popover.hover.bottomright="headerMaterials" title="存在Bom Header"
                              @click="downloadWithHeader(downloadBomHeaderDetail(),'Bom Headers.zip')">
                        Bom Header
                    </b-button>
                </template>
            </workflow-task-batch>
        </b-overlay>
    </common-page>
</template>
<script>
// Author Lin
// Date 2022-08-02 15:16:32

import WorkflowTaskBatch from "@/components/workflow/WorkflowTaskBatch.vue";
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

const PC2PH = {
    'P20R04681': '202OGL172-OG468100',
    'P20R00401': '202KBK171-PG048300',
    'P20R00481': '202KPK175-PG048102',
    'P20R00483': '202KPK176-PG041801',
    'P20R04682': '202OGKUC4-OG468200',
    'P20R00489': '202KPK403-PG041801',
    'P20R00488': '202KPK411-PG041801',
    'P20R00487': '202KPK419-PG041801',
    'P20R00403': '202KBK171-PG048301',
    'P20R00404': '202KBK171-PG048302',
    'P20R00486': '202KPK175-PG048103',
    'P20400002': '202KBK171-PG048300',
}

export default {
    name: "sithMesMstMaterialWorkflowTaskView",
    mixins: [emCommonUtilMixin],
    components: {CommonPage, WorkflowTaskBatch},
    data() {
        return {
            rows: [],
            profitCenterMap: {},
            hasInit: false,
            headerMaterials: null
        }
    },
    computed: {
        configs() {
            return {
                viewInfos: row => {
                    return [
                        {
                            title: 'BOM结构',
                            queryApi: process.env.VUE_APP_SITHMES_MST_URL + '/sithMesMstMaterial/queryBom?materialNumber=' + row.headerMaterialNumber,
                            data: {},
                            tableConfig: {
                                enable: true,
                                treeIdName: 'componentNumber',
                                treeLevelName: 'level',
                                treeParentIdName: 'parentNumber',
                                expendAll: true,
                                highLightRow: r => {
                                    if (r.componentNumber === row.material) {
                                        return 'warning';
                                    }
                                }
                            },
                        },
                        {
                            type: 'api_check',
                            needStatus: ['task7'],
                            api: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/query/waiting?material=" + row.material,
                            label: '等待中的Change流程',
                            readOnly: true
                        }
                    ]
                },
                'task_translate_zh': {
                    name: '翻译中文描述',
                    customVuexName: 'editView',
                    editFields: [
                        {key: 'materialDescriptionZH', isInput: true, require: true},
                        {key: 'textEng', isInput: true},
                        {
                            key: 'currentUserField',
                            defaultValue: 'tcMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'tcMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
                'task1': {
                    name: '确定Make/Buy',
                    customVuexName: 'editView',
                    editFields: [
                        {
                            key: 'mtype',
                            defaultValue: 'HALB',
                            isInput: true,
                            require: true
                        },
                        {
                            key: 'procType',
                            type: 'select',
                            options: [
                                {value: 'E', text: 'E'},
                                {value: 'F', text: 'F'},
                            ],
                            setWhenChange: val => {
                                if (this.procTypeIsE(val)) {
                                    return {'makeOrBuy': 0};
                                } else if (this.procTypeIsF(val)) {
                                    return {'makeOrBuy': 1};
                                }
                                return null;
                            },
                            isInput: true,
                            require: true
                        },
                        {key: 'makeOrBuy', isEditInvisible: true},
                        {key: 'inHouseProductionTime', isInput: true},
                        {
                            key: 'isFWithBom',
                            label: '整体打包',
                            type: 'select',
                            options: [
                                {value: 0, text: '是'},
                                {value: 1, text: '否'},
                            ],
                            setWhenChange: val => {
                                return val === 0 ? {'longText': 'SCM F-with BOM'} : {'longText': ''};
                            },
                            isInput: true
                        },
                        {key: 'longText', isEditInvisible: true},
                        {key: 'textMp', isInput: true},
                        {
                            key: 'currentUserField',
                            defaultValue: 'mpMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'mpMaintainTime',
                            isEditInvisible: true
                        }
                    ],
                    setApprove: (approve, variables) => {
                        if (variables.makeOrBuy !== undefined) {
                            return variables.makeOrBuy;
                        }
                        return approve;
                    }
                },
                'task2': {
                    name: '维护财务主数据',
                    customVuexName: 'editView',
                    editFields: [
                        {key: 'taxCategory', defaultValue: 'MWST', isInput: true},
                        {key: 'taxClass', defaultValue: '0', isInput: true},
                        {key: 'deliveryPlant', defaultValue: '3TH1', isInput: true},
                        {key: 'cashDiscount', defaultValue: 'X', isInput: true},
                        {key: 'accountGroup', defaultValue: '01', isInput: true},
                        {key: 'matStatisticsGroup', defaultValue: '1', isInput: true},
                        {
                            key: 'generalItemCategoryGroup',
                            changeByRow: row => {
                                if (this.procTypeIsE(row.procType)) {
                                    return 'ZP83';
                                } else {
                                    if (this.profitCenterIsTrading(row.profitCenter)) {
                                        return 'BANS';
                                    } else {
                                        return 'BANC';
                                    }
                                }
                            },
                            setWhenChange: val => {
                                return {'itemCategoryGroup': val}
                            },
                            isInput: true
                        },
                        {key: 'itemCategoryGroup', isInput: true},
                        {
                            key: 'productHierarchy',
                            changeByRow: row => {
                                return PC2PH[row.profitCenter];
                            },
                            isInput: true
                        },
                        {key: 'loadingGroup', defaultValue: '0150', isInput: true},
                        {key: 'availabilityCheck', defaultValue: '02', isInput: true},
                        {
                            key: 'profitCenter',
                            defaultValue: row => {
                                let item = this.profitCenterMap[row.projectPlanId];
                                return item ? item.profitCenter : "";
                            },
                            isInput: true, require: true
                        },
                        {key: 'transportGroup', defaultValue: '0001', isInput: true},
                        {
                            key: 'overheadGroup',
                            defaultValue: row => {
                                let item = this.profitCenterMap[row.projectPlanId];
                                return item ? item.costOverheadGroup : "";
                            },
                            isInput: true, require: true
                        },
                        {
                            key: 'valuationClass',
                            changeByRow: row => {
                                if (this.procTypeIsE(row.procType)) {
                                    return '7900';
                                } else {
                                    if (this.profitCenterIsTrading(row.profitCenter)) {
                                        return '3012';
                                    } else {
                                        return '3010';
                                    }
                                }
                            },
                            isInput: true
                        },
                        {
                            key: 'priceUnit',
                            defaultValue: row => {
                                return row.bunit === 'MM' ? '1000' : '1';
                            },
                            isInput: true
                        },
                        {key: 'standardPrice', defaultValue: '0.01', isInput: true},
                        {
                            key: 'priceControl',
                            changeByRow: row => {
                                return this.procTypeIsE(row.procType)
                                && row.mtype === 'HALB'
                                && this.profitCenterIsStock(row.profitCenter) ? 'S' : 'V';
                            },
                            isInput: true
                        },
                        {key: 'withQtyStructure', defaultValue: 'X', isInput: true},
                        {
                            key: 'currentUserField',
                            defaultValue: 'baMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'baMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
                'task3': {
                    name: '维护OM主数据',
                    customVuexName: 'editView',
                    editFields: [
                        {key: 'lotSize', defaultValue: 'EX', isInput: true},
                        {key: 'mrpType', defaultValue: 'PD', isInput: true},
                        {key: 'mrpController', defaultValue: 'H04', isInput: true},
                        {key: 'schedulingMarginKey', defaultValue: '000', isInput: true},
                        {key: 'consumptionMode', defaultValue: '2', isInput: true},
                        {key: 'fwdConsPer', defaultValue: '999', isInput: true},
                        {key: 'bwdConsPer', defaultValue: '999', isInput: true},
                        {key: 'mixedMrpIndicator', defaultValue: '1', isInput: true},
                        {
                            key: 'proSheProfile',
                            defaultValue: row => {
                                return this.procTypeIsE(row.procType) ? '000001' : '';
                            },
                            isInput: true
                        },
                        {key: 'strategyGroup', defaultValue: '70', isInput: true},
                        {
                            key: 'individualColl',
                            type: 'select',
                            options: [
                                {value: '1', text: 'PTO'},
                                {value: '2', text: 'PTS'}
                            ],
                            require: true,
                            isInput: true
                        },
                        {
                            key: 'currentUserField',
                            defaultValue: 'omMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'omMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
                'task5': {
                    name: '维护ITP文件号',
                    customVuexName: 'editView',
                    editFields: [
                        {key: 'textQa', isInput: true, /*require: true*/},
                        {
                            key: 'currentUserField',
                            defaultValue: 'qmMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'qmMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
                'task6': {
                    name: '维护采购主数据',
                    customVuexName: 'editView',
                    editFields: [
                        // {key: 'matGroup', isInput: true},
                        {key: 'minLotSze', isInput: true},
                        {key: 'purchasingGroup', isInput: true},
                        {key: 'plannedDeliveryTime', isInput: true},
                        {key: 'grProcessingTime', isInput: true},
                        {
                            key: 'currentUserField',
                            defaultValue: 'purchaser',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'purchaserMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
                'task7': {
                    name: '主数据扩展',
                    customVuexName: 'editView',
                    editFields: [
                        {key: 'plant', defaultValue: '3TH1', isInput: true},
                        {key: 'salesOrg', defaultValue: '00H1', isInput: true},
                        {key: 'distChannel', defaultValue: 'O1', isInput: true},
                        {key: 'textId', defaultValue: 'BEST', isInput: true},
                        {key: 'languageKey', defaultValue: 'E', isInput: true},
                        {
                            key: 'safetyTime1',
                            defaultValue: row => {
                                return this.procTypeIsE(row.procType) ? 1 : 2;
                            },
                            isInput: true
                        },
                        {key: 'safetyTime2', defaultValue: 5, isInput: true},
                        {
                            key: 'currentUserField',
                            defaultValue: 'doMaintainer',
                            isEditInvisible: true
                        },
                        {
                            key: 'currentDateField',
                            defaultValue: 'doMaintainTime',
                            isEditInvisible: true
                        }
                    ]
                },
            }
        },
        rowIds() {
            return this.rows.map(o => o.id).join(",");
        },
        endCallApi() {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesMstMaterial/complete-feedback";
        },
    },
    created() {
        if (this.$route.params.rows) {
            this.rows = this.$route.params.rows;
            if (this.rows && this.rows.length > 0) {
                let status = this.rows[0].status;
                if (status === 'task7') {
                    this.checkIfBomHeader();
                }
                if (status === 'task2') {
                    let tempList = [], has = false;
                    this.rows.forEach(o => {
                        if (o.projectPlanId) {
                            has = true;
                            tempList.push(o.projectPlanId);
                        }
                    });
                    if (has) {
                        this.$store.dispatch('api/post', {
                            url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectProfitCenter/query",
                            data: tempList
                        }).then(response => {
                            if (response && response.data) {
                                this.profitCenterMap = response.data;
                            }
                        }).finally(() => this.hasInit = true);
                        return;
                    }
                }
            }
        }
        this.hasInit = true;
    },
    methods: {
        procTypeIsE(pt) {
            return pt === 'E';
        },
        procTypeIsF(pt) {
            return pt === 'F';
        },
        profitCenterIsStock(pc) {
            return pc === 'P20R00401';
        },
        profitCenterIsTrading(pc) {
            return pc === 'P20400002';
        },
        downloadTxtZipUrl() {
            return process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/downloadTxt?materialIds=" + this.rowIds;
        },
        checkIfBomHeader() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/checkIfBomHeader?materialIds=" + this.rowIds
            }).then(response => {
                console.log(response);
                if (response) {
                    this.headerMaterials = response;
                }
            })
        },
        downloadBomHeaderDetail() {
            return process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/downloadBomHeader?materials=" + this.headerMaterials;
        },
    }
};
</script>
